import React from 'react';

interface IFontAwesomeProps {
  type: string;
  name: string;
  classname?: string;
}

const FontAwesome = ({ type, name, classname }: IFontAwesomeProps) => (
  <i className={`${type} fa-${name} ${classname || ''}`} />
);

export default FontAwesome;
